import React from 'react';

import ExpandablePanel from './components/ExpandablePanel';
import { REPORT_CONTROL_TYPE } from './constants/report-designer.constants';
import SSChart from './controls/ssChart';
import SSCrossTab from './controls/ssCrossTab';
import SSDistributionContent from './controls/ssDistributionContent';
import SSGroupHeader from './controls/ssGroupHeader';
import SSReportConditionsTable from './controls/ssReportConditionsTable';
import SSReportContainer from './controls/ssReportContainer';
import SSReportTab from './controls/ssReportTab';
import SSReportText from './controls/ssReportText';
import SSSimpleBlock from './controls/ssSimpleBlock';

export const getControl = ({ controlType, ...props }) => {
  switch (controlType) {
    case REPORT_CONTROL_TYPE.LAYOUT:
    case REPORT_CONTROL_TYPE.FILTER_AND_SORT:
    case REPORT_CONTROL_TYPE.DISTRIBUTION_TAB:
      return <SSReportTab {...props} controlType={controlType} />;

    case REPORT_CONTROL_TYPE.TOP_CHART:
    case REPORT_CONTROL_TYPE.BOTTOM_CHART:
    case REPORT_CONTROL_TYPE.CROSS_TAB_CONTAINER:
    case REPORT_CONTROL_TYPE.GROUP_HEADER_CONTAINER:
    case REPORT_CONTROL_TYPE.DATA_COLUMN_CONTAINER:
      return (
        <ExpandablePanel controlType={controlType}>
          <SSReportContainer {...props} controlType={controlType} />
        </ExpandablePanel>
      );

    case REPORT_CONTROL_TYPE.FILTER_CONDITION_CONTAINER:
    case REPORT_CONTROL_TYPE.DATA_FILTER_CONDITION_CONTAINER:
    case REPORT_CONTROL_TYPE.SORT_CONDITION_CONTAINER:
      return (
        <ExpandablePanel controlType={controlType}>
          <SSReportConditionsTable {...props} controlType={controlType} />
        </ExpandablePanel>
      );

    case REPORT_CONTROL_TYPE.DISTRIBUTION:
      return <SSDistributionContent {...props} />;

    case REPORT_CONTROL_TYPE.CROSS_TAB:
      return <SSCrossTab {...props} />;

    case REPORT_CONTROL_TYPE.PAGE_HEADER:
    case REPORT_CONTROL_TYPE.PAGE_FOOTER:
      return <SSReportText {...props} controlType={controlType} />;

    case REPORT_CONTROL_TYPE.GROUP_HEADER:
      return <SSGroupHeader {...props} />;

    case REPORT_CONTROL_TYPE.CHART:
      return <SSChart {...props} />;

    case REPORT_CONTROL_TYPE.GROUP_TREND:
    case REPORT_CONTROL_TYPE.DATA_COLUMN:
    case REPORT_CONTROL_TYPE.CHART_VALUE:
    case REPORT_CONTROL_TYPE.CHART_GROUP:
    case REPORT_CONTROL_TYPE.CROSS_TAB_COLUMN:
    case REPORT_CONTROL_TYPE.CROSS_TAB_DATA:
    case REPORT_CONTROL_TYPE.CROSS_TAB_ROW:
      return <SSSimpleBlock {...props} controlType={controlType} />;

    case REPORT_CONTROL_TYPE.REPORT_INFO:
      return null;

    default:
      return <div>{controlType}</div>;
  }
};
